import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const longevity = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
